import { defineComponent as _defineComponent } from 'vue';
import AdminLayout from "@/Layouts/Admin.vue";
import { Head, usePage } from "@inertiajs/inertia-vue3";
import Card from "primevue/card";
import { useRoute } from "../../Plugins/ziggy";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    setup(__props, { expose }) {
        expose();
        const route = useRoute();
        const page = usePage();
        const user = page.props.value.auth.user;
        const cards = [
            {
                title: "Gestisci le Aziende",
                icon: "ico_azienda",
                route: route("admin.companies.index"),
            },
            {
                title: "Aggiungi una azienda",
                icon: "ico_azienda",
                route: route("admin.companies.index") + '#add',
            },
            {
                title: "Gestisci stazioni meteo",
                icon: "icoMeteo",
                route: route('admin.weather-stations.index'),
            },
            {
                title: "Aggiungi una stazione meteo",
                icon: "icoMeteo",
                route: route("admin.weather-stations.index") + '#add',
            },
            {
                title: "Configura nutrizione",
                icon: "ico_nutrizione",
                route: "",
            },
        ];
        const __returned__ = { route, page, user, cards, AdminLayout, get Head() { return Head; }, get Card() { return Card; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
